import React, { useState } from 'react';

const RoleComponent = () => {
  const [roles, setRoles] = useState([]);
  const [roleName, setRoleName] = useState('');
  const [editingId, setEditingId] = useState(null);

  const handleAddOrUpdate = () => {
    if (!roleName.trim()) return;

    if (editingId !== null) {
      setRoles(prev =>
        prev.map(role => (role.id === editingId ? { ...role, name: roleName } : role))
      );
      setEditingId(null);
    } else {
      const newRole = {
        id: Date.now(),
        name: roleName,
      };
      setRoles(prev => [...prev, newRole]);
    }

    setRoleName('');
  };

  const handleEdit = role => {
    setRoleName(role.name);
    setEditingId(role.id);
  };

  const handleDelete = id => {
    setRoles(prev => prev.filter(role => role.id !== id));
    if (editingId === id) {
      setEditingId(null);
      setRoleName('');
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4 bg-white rounded shadow">
      <h2 className="text-2xl font-semibold mb-4">Manage Roles</h2>

      {/* Input */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Enter role name"
          className="flex-1 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={roleName}
          onChange={e => setRoleName(e.target.value)}
        />
        <button
          onClick={handleAddOrUpdate}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {editingId !== null ? 'Update' : 'Add'}
        </button>
      </div>

      {/* Role List */}
      <ul className="space-y-2">
        {roles.map(role => (
          <li
            key={role.id}
            className="flex justify-between items-center border border-gray-200 rounded px-3 py-2"
          >
            <span>{role.name}</span>
            <div className="space-x-2">
              <button
                onClick={() => handleEdit(role)}
                className="text-sm text-blue-600 hover:underline"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(role.id)}
                className="text-sm text-red-600 hover:underline"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RoleComponent;
